import PropTypes from 'prop-types';
import React from 'react';
import {
  NavItem,
  Nav,
  Col,
  Tab,
  Row,
} from 'react-bootstrap';
import { browserHistory } from 'react-router';

import TourOverviewTabContainer from './TourOverviewTabContainer';
import TourRouteTabContainer from './TourRouteTabContainer';
import TourRosterTabContainer from './TourRosterTabContainer';
import TourHotelTab from './TourHotelTab';
import TourHotelTabViewer from './TourHotelTabViewer';
import TourFlightTab from './TourFlightTab';
import TourCalendarTabContainer from './TourCalendarTabContainer';
import TourMessages from './TourMessages';
import { tour } from '../../booking/components/BookingPropTypes';


class TourNavTabs extends React.Component {

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(key) {
    const url = `/tours/${this.props.tour.id}/${key}`;
    browserHistory.push(url);
  }
  proposalCall=()=>{
    this.props.requestProposals(this.props.tour.id)
  }

  render() {
    try {
      // const active
      const readOnly = (this.props.tour.state === 'AR');
      const readOnlyOrTourManager = (this.props.tour.state === 'AR') || this.props.isTourManager;
      const showHotels = (
          (this.props.tour.groups.length !== 0) && (this.props.tour.cities !== 0)
          && !readOnly);
      const isTourManager = this.props.isTourManager;
      const showCalendar = (this.props.tour.cities !== 0);
      const showFlights = false;

      const activeKey = this.props.active ? this.props.active : 'overview';
      return (
        <div className="container-fluid">
          <TourMessages
            messages={this.props.messages}
            messageDismiss={this.props.messageDismiss}
          />
          <Tab.Container
            id="tabs-with-dropdown"
            onSelect={this.handleSelect}
            activeKey={activeKey}
          >
            <Row className="clearfix">
              <Col sm={12}>
                <Nav bsStyle="tabs">
                  <NavItem eventKey="overview">
                    <i className="fa fa-briefcase" aria-hidden /> Overview
                 </NavItem>
                  <NavItem eventKey="routing" onClick={this.proposalCall} >
                    <i className="fa fa-map-signs" aria-hidden /> Routing
                </NavItem>
                  <NavItem eventKey="participants">
                    <i className="fa fa-users" aria-hidden /> Travel Party
                 </NavItem>
                  {showHotels && (
                  <NavItem eventKey="hotels">
                    <i className="fa fa-hotel" aria-hidden /> Hotels
                  </NavItem>
                  )}
                  {readOnly && (
                  <NavItem eventKey="hotels">
                    <i className="fa fa-hotel" aria-hidden /> Hotels
                  </NavItem>
                  )}
                  {showFlights && (
                  <NavItem eventKey="flights" disabled>
                    <i className="fa fa-plane" aria-hidden /> Flights
                  </NavItem>
                  )}
                  {showCalendar && (
                  <NavItem eventKey="calendar" onClick={this.proposalCall} >
                    <i className="fa fa-calendar" aria-hidden /> Calendar
                  </NavItem>
                  )}
                </Nav>
              </Col>
              <Col sm={12}>
                <Tab.Content animation mountOnEnter>
                  <Tab.Pane eventKey="overview" mountOnEnter >
                    <TourOverviewTabContainer readOnly={readOnly} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="routing" mountOnEnter>
                    <TourRouteTabContainer
                      tour={this.props.tour}
                      detailTab={this.props.detailTab}
                      readOnly={readOnlyOrTourManager}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="participants" mountOnEnter>
                    <TourRosterTabContainer
                      tour={this.props.tour}
                      detailTab={this.props.detailTab}
                      readOnly={readOnlyOrTourManager}
                    />
                  </Tab.Pane>
                  {!readOnlyOrTourManager && (
                  <Tab.Pane eventKey="hotels" mountOnEnter>
                    <TourHotelTab
                      requestBidsets={this.props.requestBidsets}
                      requestProposals={this.props.requestProposals}
                      tour={this.props.tour}
                      detailTab={this.props.detailTab}
                      detailSelect={this.props.detailSelect}
                      readOnly={readOnly}
                      requestBidDetails={this.props.requestBidDetails}
                    />
                  </Tab.Pane>
                  )}
                  {readOnlyOrTourManager && (
                  <Tab.Pane eventKey="hotels" mountOnEnter>
                    <TourHotelTabViewer
                      tour={this.props.tour}
                      detailTab={this.props.detailTab}
                      detailSelect={this.props.detailSelect}
                      readOnly={readOnly}
                      isTourManager={this.props.isTourManager}
                    />
                  </Tab.Pane>
                  )}
                  {showFlights && (
                  <Tab.Pane eventKey="flights" mountOnEnter >
                    <TourFlightTab
                      tour={this.props.tour}
                      detailTab={this.props.detailTab}
                    />
                  </Tab.Pane>
                  )}
                  {showCalendar && (
                  <Tab.Pane eventKey="calendar" mountOnEnter>
                    <TourCalendarTabContainer
                      tour={this.props.tour}
                      detailTab={this.props.detailTab}
                      readOnly={readOnly}
                    />
                  </Tab.Pane>
                )}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      );
  } catch (e) {
    console.log(e);
    return null;
  }
  }
}

// <TourHotelTab tour={this.props.tour} />

TourNavTabs.propTypes = {
  isTourManager: PropTypes.bool.isRequired,
  detailTab: PropTypes.string,
  active: PropTypes.string,
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  messageDismiss: PropTypes.func.isRequired,
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    state: PropTypes.string.required,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    groups: PropTypes.arrayOf(PropTypes.object).required,
    members: PropTypes.arrayOf(PropTypes.object).required,
    routes: PropTypes.arrayOf(PropTypes.object).required,
    events: PropTypes.arrayOf(PropTypes.object).required,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

TourNavTabs.defaultProps = {
  detailTab: null,
  active: null,
  tour: {
    id: 0,
    state: 'draft',
    start: null,
    end: null,
    routes: [],
    groups: [],
    members: [],
    events: [],
    image: 'https://www.whyy.org/img/ontour_logocrop.png',
  },
};
export default TourNavTabs;



// WEBPACK FOOTER //
// src/routes/tours/components/TourNavTabs.js